import React from 'react';
import { Grid } from '@material-ui/core';
import Proptypes from 'prop-types';
import FormSection from '../../../../components/FormComponents/FormSection';
import DateInputFieldWithValidation from '../../../../components/ValidationFormElements/DateInputFieldWithValidation';
import TextInputFieldWithValidation from '../../../../components/ValidationFormElements/TextInputFieldWithValidation';
import AccidentInfoIcon from '../../../../img/formSectionIcons/accidentInfo.svg';
import { NON_DIGITS_PATTERN } from '../../../../constants/patterns';
import AccidentTime from '../../../CompensationContainer/components/AccidentTime';

const AccidentInformation = ({
  accDate,
  updateAccDate,
  damageAmount,
  updateDamageAmount,
  accidentInfo,
  formProps: { errors, clearError, setValue, register },
}) => (
  <FormSection icon={AccidentInfoIcon} title="propertyClaim.accInfo.accInfo">
    <Grid container spacing={4}>
      <Grid item md={4} xs={12}>
        <DateInputFieldWithValidation
          formProps={{ errors, clearError }}
          labelKey="propertyClaim.accInfo.date"
          name="accidentDate"
          value={accDate || null}
          handleChange={(date) => {
            // eslint-disable-next-line no-restricted-globals
            if (date instanceof Date && !isNaN(date)) {
              updateAccDate(date);
            }
          }}
          maxDate={new Date()}
          required
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <AccidentTime
          accidentInfo={accidentInfo}
          formProps={{ errors, clearError, setValue, register }}
        />
      </Grid>
      <Grid item md={4} xs={12}>
        <TextInputFieldWithValidation
          required
          formProps={{
            errors,
            clearError,
          }}
          labelKey="propertyClaim.accInfo.damageAmount"
          name="damageAmount"
          handleChange={(event) => {
            const currentValue = event.target.value;
            const fixedValue = currentValue.replace(NON_DIGITS_PATTERN, '');
            updateDamageAmount(Number(fixedValue));
          }}
          type="tel"
          value={damageAmount ? damageAmount.toLocaleString() : ''}
        />
      </Grid>
    </Grid>
  </FormSection>
);

AccidentInformation.propTypes = {
  formProps: Proptypes.shape({
    errors: Proptypes.shape({}),
    clearError: Proptypes.func,
    setValue: Proptypes.func,
    register: Proptypes.func,
  }).isRequired,
  accidentInfo: Proptypes.shape({}),
  accDate: Proptypes.instanceOf(Date),
  damageAmount: Proptypes.number,
  updateAccDate: Proptypes.func,
  updateDamageAmount: Proptypes.func,
};

AccidentInformation.defaultProps = {
  accDate: null,
  damageAmount: null,
  accidentInfo: {},
  updateAccDate: () => {},
  updateDamageAmount: () => {},
};

export default AccidentInformation;
